export default __webpack_public_path__ + "static/ieyc-image-6873bac6618c932b509cbaf61bc89f82.png";